import styled from 'styled-components';

export const NewDoctorStyled = styled.div`
  a {
    text-decoration: none;
  }
  .myDoctorSlider {
    .slick-list {
      img {
        border-radius: 0px;
      }
    }
    .card {
      width: calc(100% - 15px);
      margin: 0 7.5px;
      background: ${(props) => props.theme.color.white};
      border: 1px solid ${(props) => props.theme.color.lightGray};
      border-radius: 8px;
      position: relative;
    }
  }

  @media (max-width: 820px) {
    .container {
      padding: 0;
    }
    .row {
      .col {
        width: 50%;
        flex: inherit;
      }
    }
  }

  @media (max-width: 480px) {
    padding: 0 0 0px 0;

    .row {
      .col {
        width: 100%;
        flex: inherit;
      }
    }
  }
`;
